import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Table, Tooltip, Input, Button, Select } from "antd";

import { usrRole } from "../../utils/dataUtil";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import {
  req_page_tqa_oneyear_survey_a,
  req_downloadfile_tqa_oneyear_survey_a,
} from "../../api";
import { getNowAcademicYear } from "../../utils/dateUtil";

class OneYearSurveyA extends Component {
  state = {
    loading: false,
    yearGrade: getNowAcademicYear(new Date()) - 2,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    searchFieldExtA: "NONE",
    searchFieldExtB: "NONE",
    searchFieldExtC: "NONE",
    domnloadFile: "",
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      yearGrade,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_tqa_oneyear_survey_a(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      yearGrade,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      token
    );
    this.setState({ loading: false });
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      yearGrade,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
    } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_oneyear_survey_a(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      yearGrade,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        // const { activityNid } = item
        // Modal.confirm({
        //     title: `您確定刪除此筆數據`,
        //     onOk: () => {
        //         this.api_delete_item(activityNid)
        //     }
        // })
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "畢業學年度",
        dataIndex: "YearGrade",
        width: 25,
        fixed: true,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "部別",
        dataIndex: "Division",
        width: 40,
        fixed: true,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學制",
        dataIndex: "EducationalSystem",
        width: 30,
        fixed: true,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        width: 50,
        fixed: true,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "科系",
        dataIndex: "DepartmentName",
        width: 60,
        fixed: true,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "班級",
        dataIndex: "ClassGradeName",
        width: 40,
        fixed: true,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "總數",
        dataIndex: "AlumniTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "已調查",
        dataIndex: "SurveyTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "企業",
        dataIndex: "A1ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "公部門",
        dataIndex: "A2ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "學校",
        dataIndex: "A3ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "非營利機構",
        dataIndex: "A4ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "創業",
        dataIndex: "A5ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "自由業",
        dataIndex: "A6ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "其他",
        dataIndex: "A7ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "升學",
        dataIndex: "EduItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "家管",
        dataIndex: "A16ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "待業",
        dataIndex: "A17ItemTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
      {
        title: "未答",
        dataIndex: "NonSurveyTotal",
        width: 25,
        render: (field) => {
          return (
            <div
              style={{
                fontSize: "1.3em",
                textAlign: "center",
              }}
            >
              <span>{field}</span>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      yearGrade,
      searchFieldExtA,
      searchFieldExtB,
      searchFieldExtC,
    } = this.state;
    const title = (
      <>
        <span>調查年度</span>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={yearGrade}
          onChange={(event) => this.setState({ yearGrade: event.target.value })}
        />
        <Select
          value={searchFieldExtA}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchFieldExtA: value })}
        >
          <Select.Option value="NONE">部別</Select.Option>
          <Select.Option value="日間部">日間部</Select.Option>
          <Select.Option value="進修部">進修部</Select.Option>
          <Select.Option value="在職專班">在職專班</Select.Option>
          <Select.Option value="假日專班">假日專班</Select.Option>
        </Select>
        <Select
          value={searchFieldExtB}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchFieldExtB: value })}
        >
          <Select.Option value="NONE">學制</Select.Option>
          <Select.Option value="四技">四技</Select.Option>
          <Select.Option value="二技">二技</Select.Option>
          <Select.Option value="七技">七技</Select.Option>
          <Select.Option value="研究所">研究所</Select.Option>
          <Select.Option value="二專">二專</Select.Option>
          <Select.Option value="三專">三專</Select.Option>
          <Select.Option value="五專">五專</Select.Option>
        </Select>
        <Select
          value={searchFieldExtC}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchFieldExtC: value })}
        >
          <Select.Option value="NONE">學院</Select.Option>
          <Select.Option value="生活科技學院">生活科技學院</Select.Option>
          <Select.Option value="旅遊學院">旅遊學院</Select.Option>
          <Select.Option value="藝術學院">藝術學院</Select.Option>
          <Select.Option value="管理學院 ">管理學院</Select.Option>
          <Select.Option value="設計學院 ">設計學院</Select.Option>
        </Select>
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">其他條件</Select.Option>
          <Select.Option value="DepartmentName">科系名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "4px" }}
        >
          <i className="fas fa-cloud-download-alt element-hidden"></i> 下載
        </Button>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(OneYearSurveyA);
